import PromotionStatistics from './PromotionStatistics';

export default PromotionStatistics;
